import React from 'react'
import _ from 'lodash'
import axios from 'axios'
import immutable from 'immutable'

import {AutoComplete} from '../../widgets/autocomplete/autocomplete.component'
import ViewDestinationContainer from './viewdestination.container'
import {PromotedRegionBand} from '../../widgets/promotedregionband.component'
import mixpanelUtil from '../../util/mixpanel.util'


const ELASTISEARCH_URL = '/api/v1/destinations/search/'
const OPENCAGE_URL = '/api/v1/destinations/geocoder/search/'
const OPENCAGE_POST_URL = '/api/v1/destinations/geocoder/save/'
const SABRE_URL = '/api/v1/sabre/search/'
const SEARCH_URL = '/api/v1/destinations/info/'

export class AddDestination extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            isDestinationView: false,
            activeDestination: null
        }

        _.bindAll(this,
            'onExecuteQuery',
            'onRenderResult',
            'onChoose',
            'onShowSearch',
            'onShowDestination',
            'onSetDestination',
            'getResultById',
            'showRelatedDetails'
        )
    }

    onShowSearch() {
        this.setState({activeDestination: null, isDestinationView: false})
    }

    onShowDestination() {
    }

    onSetDestination(dest) {
        this.props.onSelectDestination(this.props.leg, dest)
        this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.DESTINATION, this.props.availableDetailSubSections.OVERVIEW)
    }

    onExecuteQuery(q) {
        mixpanelUtil.send(
            'Searched destination',
            {
                'trip': this.props.tripGuid,
                'query': q
            }
        )
        return axios.get(ELASTISEARCH_URL, {
            params: {
                query: q
            }
        }).then((response) => {
            const results = response.data.results
            if (results.length === 0) {
                mixpanelUtil.send(
                    'Destination zero results',
                    {
                        'trip': this.props.tripGuid,
                        'query': q
                    }
                )
            }
            return results
        })
    }

    onOpenCageQuery(q) {
        return axios.get(OPENCAGE_URL, {
            params: {
                address: q
            }
        }).then((response) => response.data.data)
    }

    onSabreQuery(q) {
        return axios.get(SABRE_URL, {
            params: {
                address: q
            }
        }).then((response) => response.data.data)
    }

    onRenderResult(result) {
        // TODO: Seems easiest to cast as immutable for consistency but not sure if necessary
        let tResult = new immutable.fromJS(result)

        let rType = ''
        let rLabel = ''

        if (tResult.get('type') === 'opencage') {
            rType = tResult.getIn(['components', '_type'])
            switch (rType) {
                case 'state':
                    rLabel = tResult.getIn(['components', 'country'])
                    break
                default:
                    rLabel = tResult.getIn(['components', 'state'])
                    break
            }
            if (tResult.getIn(['components', 'country_code']) === 'us') {
                rLabel += ' (US)'
            }
        } else {
            rType = tResult.getIn(['opencage', 'oc_type'])
            switch (rType) {
                case 'state':
                case 'local_administrative_area':
                case 'opencage':
                    rLabel = tResult.getIn(['opencage', 'country'])
                    if (rLabel == 'United States of America') {
                        rLabel = tResult.getIn(['opencage', 'state'])
                    }
                    break
                default:
                    rLabel = tResult.getIn(['opencage', 'state'])
                    break
            }
            if (rType === 'opencage') {
                rType = 'city' // TODO: Need more data to see how to set this
            }
        }
        return (
            <div className="result-item">
                <div className="result-label">
                    <div className="result-name">{result.name}</div><div className="result-state">{ rLabel }</div>
                </div>
                <div className="result-type">{ rType }</div>
            </div>
        )
    }

    // moved this functionality to the view destination component
    getResultById(id) {
        let self = this
        axios.get(SEARCH_URL + 'info/' + id, {
            params: {
                with: 'opencage'
            }
        }).then(function(response) {
            if (response.data !== undefined) {
                self.setState({activeDestination: immutable.fromJS(response.data.data), isDestinationView: true})
            } else {
                console.error('ERROR: in getResultByID function')
            }
        })
    }

    onChoose(choice) {
        var self = this

        if (choice.type !== 'opencage') {
            // TODO: need to get the id out of the choice and save to state
            this.setState({activeDestination: immutable.fromJS(choice), isDestinationView: true})
            mixpanelUtil.send('selectedDestination', {'name': choice.name, 'destination_id': choice.id, 'source': 'database'})
            // this.getResultById(choice.id)
        } else {
            let newName = choice.components[choice.components._type]
            if (newName === undefined) {
                newName = _.split(choice.formatted.replace(/["]+/g, ''), ',', 1)[0]
            }

            mixpanelUtil.send('selectedDestination', {'name': newName, 'destination_id': -1, 'source': 'opencage'})

            // post data
            axios.post(OPENCAGE_POST_URL, {
                destination: choice.components[choice.components._type] ? choice.components[choice.components._type] : choice.name,
                data: choice
            },
            {
                validateStatus: function (status) {
                    return status < 500 // Reject only if the status code is greater than or equal to 500
                }
            }
            )
                .then(function(response) {
                    // TODO: should get an id back –– add it to the state, we'll need it!
                    // set the destination id
                    if (typeof response.data !== 'undefined') {
                        self.setState({activeDestination: immutable.fromJS(response.data), isDestinationView: true})
                    }
                })
                .catch(function(error) {
                    console.error('Error Saving new opencage item')
                    console.error(error)

                    if (error.response) {
                        console.error(error.response.data)
                        if (typeof error.response.data != 'undefined' && typeof error.response.data.data != 'undefined') {
                            // set the destination id
                            // formattedChoice.id = error.response.data.data.id;
                            // TODO: not sure what this error is catching, if it errors do we have an id?
                        }
                    } else {
                        console.error('Error', error.message)
                    }
                    // set default choice with no identifier
                    // self.setState({ activeDestination: formattedChoice, isDestinationView: true})
                    // self.props.onSelectDestination(self.props.leg,formattedChoice)
                })
        }
    }

    expandSearch() {
    }

    showRelatedDetails(destination) {
        this.onChoose(destination)
    }

    getContent() {
        if (this.state.isDestinationView) {
            return (
                <div>
                    <ViewDestinationContainer
                        {...this.props}
                        activeDestination={this.state.activeDestination}
                        onShowSearch={this.onShowSearch}
                        onShowDestination={this.onShowDestination}
                        onSetDestination={this.onSetDestination}
                        showDetails={this.showRelatedDetails}/>
                </div>
            )
        } else {
            return (
                <div>
                    <div className="view-area">
                        <div className="view-left-col"/>
                        <div className="view-center">
                            <div className="section-title">
                                <h1>Add a Destination</h1>
                                <p>
                Enter a city or region name below.<br/>
                If you don't find what you're looking for, <a href="mailto:hello@lunamoons.com"><u>let us</u></a> know what to cover next.
                                </p>
                            </div>
                            <AutoComplete
                                onExecuteQuery={this.onExecuteQuery}
                                onRenderResult={this.onRenderResult}
                                onChoose={this.onChoose}
                                placeholder='Destination Search'/>
                            <p className="instruction-text">Not sure where to go? Check out a few of our favorite destinations below.</p>
                        </div>
                        <div className="view-right-col"/>
                    </div>
                    <PromotedRegionBand region="france" showDetails={this.showRelatedDetails}/>
                    <PromotedRegionBand region="italy" showDetails={this.showRelatedDetails}/>
                    <PromotedRegionBand region="hawaii" showDetails={this.showRelatedDetails}/>
                </div>
            )
        }
    }

    render() {
        let showContent = this.getContent()
        return (
            <div>
                {showContent}
            </div>
        )
    }
}
